import { CONNECTOR_TYPES } from '@/vars/general'

type BotChannelListItem = {
    id?: string
    name?: string
    botConnectorId?: string
}

type ProjectConnector = {
    connectorId?: string
    connectorType?: string
    name?: string
    defaultName?: string
    bot?: {
        name?: string
    }
    data?: {
        name?: string
    }
}

export const normalizeBotChannelList = (
    rawList: BotChannelListItem[] | null = [],
    connectors: ProjectConnector[] = []
) => {
    const safeRawList = Array.isArray(rawList) ? rawList : []
    const connectorTypeNames: Record<string, string> = {
        [CONNECTOR_TYPES.whatsapp]: 'WhatsApp',
        [CONNECTOR_TYPES.whatsappBasis]: 'WhatsApp',
        [CONNECTOR_TYPES.telegramHr]: 'Telegram',
        [CONNECTOR_TYPES.maxBusiness]: 'MAX Business',
    }

    return safeRawList.map((item) => {
        if (item?.id && item?.name) {
            return item
        }

        const connectorId = item?.id || item?.botConnectorId
        const connector = connectors.find(
            (projectConnector) => projectConnector?.connectorId === connectorId
        )

        return {
            id: connectorId,
            name:
                connector?.name ||
                connector?.defaultName ||
                connector?.bot?.name ||
                connector?.data?.name ||
                (connector?.connectorType
                    ? connectorTypeNames[connector.connectorType]
                    : undefined) ||
                connectorId,
        }
    })
}
